export default __webpack_public_path__ + "static/media/single-01-entrance-active.74aaf5ea.webp";